exports.onClientEntry = () => {
  const Hammer = require("hammerjs");
  window.Hammer = Hammer;
};
